import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {ReportService} from '../../service/report.service';

@Component({
  selector: 'app-filter-save',
  templateUrl: './filter-save.component.html',
  styleUrls: ['./filter-save.component.scss']
})
export class FilterSaveComponent implements OnInit {
 public crossTabSave = new FormGroup({
    name : new FormControl('', [Validators.required]),
  });
  public sigTabSave = new FormGroup({
    name : new FormControl('', [Validators.required]),
  });
  constructor(public reportService:ReportService) { }

  ngOnInit() {
  }

  onSubmit(){
    // console.log("name is ==> "+this.crossTabSave.value.name);
    if (this.crossTabSave.value.name && this.crossTabSave.value.name != '') {
      this.reportService.saveCrossTabs(this.crossTabSave.value.name)
    }
    // this.reportService.saveCrossTabs()
  }
  onSigSubmit(){
    if (this.sigTabSave.value.name && this.sigTabSave.value.name != '') {
      this.reportService.saveSigTabs(this.sigTabSave.value.name)
    }
  }
}
